import { useMemo } from 'react';

export const useIsLoading = (loadingStates: boolean[]) =>
  useMemo(() => loadingStates.some((loading) => loading), [loadingStates]);
